$(document).ready(function () {
  // 最新消息彙整頁, 標籤頁, 分類頁
  if ( $('.frame').data('page') == 'posts' || $('.frame').data('page') == 'posts-tag' || $('.frame').data('page') == 'posts-category' ) {
    const newsBannerAni = gsap.timeline();
    newsBannerAni
      .from("#news-meg", { duration: 0.3, scale: 0, ease: 'circ.out' })
      .from("#news-align", { duration: 0.3, scale: 0, ease: 'circ.out' })
      .from(".news-hand-img", { delay: 0.1, duration: 0.5, y: 180, x: 100, ease: 'circ.out' })
      .from("#news-file", { duration: 0.3, scale: 0, ease: 'circ.out' })
      .from(".showcase_bn_arrow", { delay: 0.5, duration: 0.5, opacity: 0, y: -20, stagger: 0.5, repeat: -1, repeatDelay: 3 })
  }

  // 最新消息內頁, 分類頁
  if ( $('.frame').data('page') == 'post-inner' || $('.frame').data('page') == 'posts-category' ) {
    // 文章相關頁面 - 側邊欄 快速導覽 h2 標題連結
    const $postSidemenu = $('.js-post-sidemenu');
    if ( $postSidemenu.length != 0 ) {
      // 抓取 h2 所在的目標容器
      let $postWrap = $('.js-post-content');
      let $post_h2_list = $postWrap.find('h2').not('.related-title');
      // h2 區塊的資訊
      let post_h2_data = [];
      function updatePostH2Data() {
        post_h2_data = [];
        $post_h2_list.each(function(index, h2) {
          $(h2).attr('id', `h2-${index}`);
          post_h2_data.push({
            id: `h2-${index}`,
            offsetTop: $(h2).offset().top - 30
          })
        });
      }
      if ( $post_h2_list.length != 0 ) {
        // set h2
        updatePostH2Data();
        // set sidemenu
        $postSidemenu.each(function(i, sidemenu) {
          let $postSidemenuContent = $(sidemenu).find('.post-sidemenu-content'); // 內容容器
          $postSidemenuContent.append('<ul></ul>');
          // set link anchor
          $post_h2_list.each(function(index, el) {
            $postSidemenuContent.find('ul').append(`<li class="sidemenu-item" data-id="h2-${index}"><a href="#h2-${index}">${$(el).text()}</a></li>`);
            $postSidemenuContent.find(`[href="#h2-${index}"]`).on('click', function() {
              $("html,body").animate({scrollTop: $(el).offset().top - 30}, 500);
            });
          });
        })
      }
      $(window).on('scroll', function () {
        // 如果頁面上有 postSidemenu
        if ($postSidemenu.length != 0) {
          let scrolled = $(window).scrollTop();
          $('.sidemenu-item').removeClass('active');
          // 判斷目前在哪個 h2 標籤下
          for (const d of post_h2_data) {
            if ( scrolled >= d.offsetTop ) {
              $('.sidemenu-item').removeClass('active');
              $(`[data-id="${d.id}"`).addClass('active');
            }
          }
        }
      });
      let sidemenuResizeTimer; // resize計時器
      $(window).on('resize', function() {
        clearTimeout(sidemenuResizeTimer);
        sidemenuResizeTimer = setTimeout(function () {
          // 如果頁面上有 postSidemenu
          if ($postSidemenu.length != 0) {
            updatePostH2Data()
          }
        }, 200);
      });
    }
  }

  // 子分類頁
  if ( $('.frame').data('page') == 'posts-subcategory' ) {
    const newsBannerAni = gsap.timeline();
    gsap.set(".hexagon", { transformOrigin: "center center" });
    newsBannerAni
      .from(".hexagon", {
        opacity: 0,
        duration: 1.5,
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
        stagger: function(index) {
          return index % 3 === 0 ? 0 : 0.6;
        }
      });
  }

  // 最新消息彙整頁
  if ( $('.frame').data('page') == 'posts' ) {
    // news slider bg
    const $newsSliderBG = $('#js-news-swiper-bg');
    function updateBackground(swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];
      const imgEl = activeSlide.querySelector('.image-wrap img');
      const bgUrl = imgEl ? imgEl.src : $newsSliderBG.attr('data-bg');
      $newsSliderBG.css('background-image', `url(${bgUrl})`);
    }

    // 精選文章輪播
    if ( $('#newsSlider').length > 0 ) {
      const newsSlider = new Swiper('#newsSlider', {
        loop: false,
        on: {
          init: function() {
            updateBackground(this);
          },
          slideChange: function() {
            updateBackground(this);
          }
        },
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }
  }
});
